import React from 'react';
import PropTypes from 'prop-types';
import { buildUseStyles } from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/styles';
import ModalForm2 from 'Views/Page/Content/Modal/Components/ModalForm2';
import { buildFacetDesignOverride } from 'Packages/FacetRest/FacetDesignOverride';

const metaOverrides = buildFacetDesignOverride();

const useStyles = buildUseStyles('Invisible', () => ({
  hidden: {
    display: 'none',
  },
}));

export function Invisible({ Layout }) {
  const classes = useStyles();
  return (
    <div className={classes.hidden}>
      <ModalForm2 Layout={Layout} metaOverrideSet={metaOverrides} />
    </div>
  );
}

Invisible.propTypes = {
  Layout: PropTypes.element.isRequired,
};
